module.exports = __webpack_public_path__ + "img/banner-direction-swyy.fa08f3ca.jpg";